import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

const getUploadPath = (filePath) => {
    const suffix = filePath.slice(filePath.lastIndexOf("."));
    return uuidv4() + suffix;
};

/**
 * 前端直传oss
 * @param file
 * @param ossInfo
 */
const ossUpload = (file, ossInfo, fileName) => {
    const newfileName = getUploadPath(fileName);
    const files = file;
    let param = new FormData(); // 创建form对象
    param.append("OSSAccessKeyId", ossInfo.accessid || ossInfo.accessId);
    param.append("policy", ossInfo.policy);
    param.append("key", `${ossInfo.dir}${newfileName}`);
    param.append("success_action_status", 200);
    param.append("signature", ossInfo.signature);
    param.append("file", files, newfileName);
    // 添加请求头
    return new Promise((resolve, reject) => {
        Vue.axios
            .post(ossInfo.host, param, {
                headers: { "Content-Type": "multipart/form-data" },

            })
            .then((response) => {
                if (response.status == 200) {
                    resolve({
                        path: `${ossInfo.host}/${ossInfo.dir}${newfileName}`,
                    });
                } else {
                    reject(response);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};
export default ossUpload;